import React, {useRef, useEffect} from 'react'
import Chart from 'chart.js'


const LineChart = ({xAxis, yAxis, ySet, xSet, label = ''}) => {
    const canvasRef = useRef()

    useEffect(() => {
        const chart = new Chart(canvasRef.current, {
            type: 'line',
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel: {
                            display: ySet || xSet,
                            labelString: ySet
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: ySet || xSet,
                            labelString: xSet
                        }
                    }],
                }
            },
            data: {
                labels: xAxis,
                datasets: [
                    {
                        label: label,
                        data: yAxis,
                        borderColor: 'rgba(9,84,200,0.78)',
                        borderWidth: 2,
                        fill: false
                    }
                ]
            }
        })
        return () => chart.destroy();
    }, [xAxis, yAxis])

    return (
        <React.Fragment>
            <canvas ref={canvasRef}/>
        </React.Fragment>
    )
}
export default LineChart